import { render, staticRenderFns } from "./Subelements.vue?vue&type=template&id=d0acddb8"
import script from "./Subelements.vue?vue&type=script&lang=ts"
export * from "./Subelements.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports